import React from 'react'

import Pricing from 'components/Pricing/Pricing'

const PricingContainer = () => {
  return (<Pricing />)
}

export default PricingContainer
